<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="card sw-section column is-6 mx-auto">
                    <div v-if="error.status" class="notification is-danger">
                        {{ error.message }}
                    </div>

                    <div class="sw-logo"><img src="../../assets/sw-logo.png"></div>
                    <p class="subtitle">Login with Your account or
                        <router-link to="/sw-register" class="link">Sign up</router-link>
                    </p>
                    <div class="sw-box">
                        <form>
                            <div class="sw-display">
                                <div class="sw-login-fields">
                                    <div class="field">
                                        <div class="control">
                                            <input v-model="user.email"
                                                   v-bind:class="{ 'is-danger': error.status }"
                                                   class="input"
                                                   type="email"
                                                   placeholder="Your Email"
                                                   required=""
                                                   autofocus="">
                                        </div>
                                    </div>

                                    <div class="field">
                                        <div class="control">
                                            <input v-model="user.password"
                                                   v-bind:class="{ 'is-danger': error.status }"
                                                   class="input"
                                                   type="password"
                                                   required=""
                                                   placeholder="Your Password">
                                        </div>
                                    </div>
                                    <div class="field has-text-left">
                                        <label class="checkbox">
                                            <input type="checkbox">
                                            Remember me
                                        </label>
                                    </div>
                                </div>
                                <div class="sw-social-login">
                                    <div class="social-logins has-text-right">
                                        <facebook-login class="button"
                                                        appId="597797607469702"
                                                        version="v2.9"
                                                        @login="getUserData"
                                                        @logout="onLogout"
                                                        @get-initial-status="test"
                                        >
                                        </facebook-login>

                                        <GoogleLogin :params="params" :renderParams="renderParams"
                                                     :onSuccess="onSuccess"
                                                     :onFailure="onFailure"></GoogleLogin>
                                    </div>
                                    <p class="has-text-right forgot-link">
                                        <router-link to="/login/recover" class=" link">Forgot Password
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                            <div class="sw-login-button">
                                <button @click.prevent="login" class="button is-block is-primary is-large is-fullwidth">
                                    Log
                                    In
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiAuth from '../../api/apiAuth'
    import facebookLogin from 'facebook-login-vuejs'
    import GoogleLogin from 'vue-google-login';

    export default {
        components: {
            facebookLogin,
            GoogleLogin
        },
        data() {
            return {
                user: {
                    email: '',
                    password: ''
                },
                error: {
                    status: false,
                    message: '',
                    errors: {
                        email: '',
                        password: ''
                    }
                },
                params: {
                    client_id: "857305155291-7b0rk496pnj0mk0ba66f311s977k70be.apps.googleusercontent.com"
                    //client_id: "795399958520-7aignerg3b4f3m19la81ciisto8n7vpn.apps.googleusercontent.com"
                },
                // only needed if you want to render the button with the google ui
                renderParams: {
                    width: 225,
                    height: 36,
                    longtitle: true
                }

            }
        },
        methods: {
            test(data) {
                console.log(data)
            },
            login() {
                apiAuth.loginRequest(this.user)
                    .then((response) => {
                        this.$store.commit('updateToken', response.data.token)
                        this.$store.commit('updateRole', response.data.role)
                        this.$store.commit('updateUserReferer', (response.data.referer || response.data.role == 'Affiliate') ? 1 : 0)
                        this.$store.commit('updateUserName', response.data.name)
                        this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                        this.$store.commit('updateUserDeposit', response.data.deposit)
                        this.$store.commit('updateUserDepositRate', response.data.rate)
                        this.$store.commit('updateUserManagerGoal', response.data.manager_goal)
                        this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
                        this.$router.push({path: '/system'})
                    })
                    .catch((err) => {
                        this.error.status = true
                        if (err.response && err.response.status === 422) {
                            this.error.message = 'Wrong credentials!'
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = err.response.data.errors
                        }
                    })
            },
            getUserData(response) {
                console.log(response);
                var token = response.response.authResponse.accessToken;
                var userid = response.response.authResponse.userID;
                apiAuth.socialLoginRequest({type: 'facebook', token: token, facebook_id: userid, referer: 'affiliate'})
                    .then((response) => {
                        if (response.data.details) {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', 'Visitor')
                            this.$store.commit('updateUserReferer', (response.data.user.affiliate_id || response.data.role == 'Affiliate') ? 1 : 0)
                            this.$store.commit('updateUserName', response.data.user.name)
                            this.$router.push({path: '/system'})
                        } else {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', response.data.role)
                            this.$store.commit('updateUserReferer', (response.data.user.affiliate_id || response.data.role == 'Affiliate') ? 1 : 0)
                            this.$store.commit('updateUserName', response.data.name)
                            this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                            this.$store.commit('updateUserDeposit', response.data.deposit)
                            this.$store.commit('updateUserDepositRate', response.data.rate)
                            this.$store.commit('updateUserManagerGoal', response.data.manager_goal)
                            this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
                            this.$router.push({path: '/system'})
                        }
                    })
                    .catch((err) => {
                        this.error.status = true
                        if (err.response && err.response.status === 422) {
                            this.error.message = 'Wrong credentials!'
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = err.response.data.errors
                        }
                    })
                console.log(response)
            },
            onLogout() {
                console.log('logout')
            },
            onSuccess(googleUser) {
                console.log(googleUser);
                var profile = googleUser.getBasicProfile();
                var google_id = profile.getId();
                apiAuth.socialLoginRequest({
                    type: 'google',
                    google_id: google_id,
                    name: profile.getName(),
                    email: profile.getEmail(),
                    referer: 'affiliate'
                })
                    .then((response) => {
                        if (response.data.details) {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', 'Visitor')
                            this.$store.commit('updateUserReferer', (response.data.user.affiliate_id || response.data.role == 'Affiliate') ? 1 : 0)
                            this.$store.commit('updateUserName', response.data.user.name)
                            this.$router.push({path: '/system'})
                        } else {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateUserReferer', (response.data.user.affiliate_id || response.data.role == 'Affiliate') ? 1 : 0)
                            this.$store.commit('updateRole', response.data.role)
                            this.$store.commit('updateUserName', response.data.name)
                            this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                            this.$store.commit('updateUserDeposit', response.data.deposit)
                            this.$store.commit('updateUserDepositRate', response.data.rate)
                            this.$store.commit('updateUserManagerGoal', response.data.manager_goal)
                            this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
                            this.$router.push({path: '/system'})
                        }
                    })
                    .catch((err) => {
                        this.error.status = true
                        if (err.response && err.response.status === 422) {
                            this.error.message = 'Wrong credentials!'
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = err.response.data.errors
                        }
                    })
            },
            onFailure() {
                alert('Google login not working');
            }
        }
    }
</script>

<style scoped>
    .hero {
        background: url("../../assets/hero-sw.png") no-repeat center center fixed;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

    .link {
        border-bottom: 1px solid blue;
    }

    .social-logins .container.button {
        width: auto;
        padding: 0;
        background: transparent;
        border: 0;
        display: block;
        text-align: right;
    }

    .social-logins .abcRioButton {
        margin: 10px auto;
        margin-right: 0;
    }

    .sw-display {
        display: flex;
        padding: 0 30px;
    }

    .sw-login-fields {
        flex: 1;
    }

    .sw-social-login {
        flex: 1;
    }

    p.subtitle a.link {color: #000;font-weight: 600;border-bottom: 1px solid #000;}

    .sw-logo {}

    .sw-logo img {
        width: 160px;
    }

    .sw-login-button {
        max-width: 300px;
        margin: auto;
    }
    .sw-logo {
        margin-top: 20px;
    }
    .sw-logo {
        margin-top: 20px;
    }

    p.subtitle {
        font-size: 25px;
        margin-top: 10px;
        margin-bottom: 30px!important;
    }
</style>




// WEBPACK FOOTER //
// src/components/Auth/SWLogin.vue